import { render, staticRenderFns } from "./MrpaEnableTrusteeOrganization.vue?vue&type=template&id=2f03ff18&"
import script from "./MrpaEnableTrusteeOrganization.vue?vue&type=script&lang=js&"
export * from "./MrpaEnableTrusteeOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports